import makeStyles from "utils/makeStyles";

export default makeStyles(theme => ({
    wrapper: {
        backgroundColor: "white",
        borderRadius: "10px"
    },
    header: {
        padding: "10px 20px",
    },
    toolbar: {
        padding: "10px 20px",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    crudButtons: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    content: {
        padding: "10px 20px",
    }
}));